// LDR Product Card — shared scroll-reveal + quick-add behavior for every .pcard sitewide.
// Extracted from templates/collection.mens.liquid (source of truth) so it's no longer
// hand-copied per template.
(function(){
  // Reveal pcards on scroll (slide in from right — see .pcard/.pcard.vis in ldr-product-card.css)
  // Guarded on DOMContentLoaded: this script loads in <head>, before any .pcard markup exists.
  function initReveal(){
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if (en.isIntersecting) { en.target.classList.add('vis'); io.unobserve(en.target); } });
      }, { threshold: .12, rootMargin: '0px 0px -40px 0px' });
      document.querySelectorAll('.pcard').forEach(function(el){ io.observe(el); });
    } else {
      document.querySelectorAll('.pcard').forEach(function(el){ el.classList.add('vis'); });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

  // Single delegated handler for quick-add buttons (capture phase)
  document.addEventListener('click', function(e){
    var addBtn = e.target.closest('.pcard[data-handle] .pcard-add');
    if (addBtn) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      var card = addBtn.closest('.pcard');
      var handle = card.getAttribute('data-handle');
      if (typeof window.openSizePicker === 'function') {
        window.openSizePicker(handle);
      } else {
        window.location.href = '/products/' + handle;
      }
      return;
    }
  }, true);
})();
